import { render } from "./PageBody.vue?vue&type=template&id=3e69237c&scoped=true"
const script = {}

import "./PageBody.vue?vue&type=style&index=0&id=3e69237c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e69237c"]])

export default __exports__